import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Col,
  Divider,
  Form,
  Input,
  Row,
  Typography,
  Modal as AntModal,
  Radio,
  message,
} from "antd";
import { AssessmentClickEventName } from "event-tracker/button-click-event-name";
import {
  dataLayerClickedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "shared/components";
import { UserDiagnosis } from "shared/interfaces/UserDiagnosis";
import { shareDiagnosticByEmail } from "shared/service/StrmService";

interface ModalShareDiagnosisProps {
  visible: boolean;
  onCancel: () => void;
  onSend: () => void;
  diagnosis?: UserDiagnosis;
}

const { success, error } = AntModal;

const ModalShareDiagnosis: React.FC<ModalShareDiagnosisProps> = (props) => {
  const { onSend, diagnosis, ...modalProps } = props;
  const { t } = useTranslation("radar");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedMethod, setSelectedMethod] = useState<string>("link");

  const onFinish = async () => {
    setLoading(true);
    const values: any = form.getFieldsValue(true);
    const request = {
      diagnosisId: diagnosis?.id,
      ...values,
    };
    const response: any = await shareDiagnosticByEmail(request);

    dataLayerClickedEvent(AssessmentClickEventName.SEND, {
      ...tagManagerEvent.Assessment.S4L_ARTIST_ASSESSMENT,
    });

    if (response)
      success({
        title: t("pages.Diagnostic.modalDiagnoseSuccessTitle"),
        content: t("pages.Diagnostic.modalShareDiagnoseSuccessContent"),
        icon: "",
        cancelButtonProps: {
          style: {
            display: "none",
          },
        },
        okButtonProps: {
          className: "botao-verde",
          style: { padding: 0 },
        },
        okType: "link",
        onOk() {
          console.log("ok");
        },
      });
    else
      error({
        title: t("pages.Diagnostic.modalDiagnoseErrorTitle"),
        content: t("pages.Diagnostic.modalDiagnoseErrorContent"),
        icon: "",
        cancelButtonProps: {
          style: {
            display: "none",
          },
        },
        okButtonProps: {
          className: "botao-vermelho",
          style: { padding: 0 },
        },
        okType: "link",
      });

    setLoading(false);
    onSend();
  };

  const onClickCopy = () => {
    const url = diagnosis?.diagResulUrl;
    if (url) {
      navigator.clipboard.writeText(url);
      message.success(t("pages.Diagnostic.modalDiagnoseCopySuccess"));
    }
  };

  return (
    <Modal
      {...modalProps}
      showCancelButton={false}
      okText={t("pages.Diagnostic.send")}
      onOk={onFinish}
      okButtonDisabled={loading}
      showOkButton={selectedMethod === "email"}
    >
      <div className="modal-share-diagnose">
        <Typography.Title
          level={5}
          style={{ color: "#fff", textAlign: "start", marginBottom: 0 }}
        >
          {t("pages.Diagnostic.shareModalModalTitle")}
        </Typography.Title>
        <Divider style={{ backgroundColor: "#E0E2E7" }} />
        {selectedMethod === "link" && (
          <Typography.Paragraph style={{ color: "#fff", textAlign: "left" }}>
            {t("pages.Diagnostic.shareModalLinkDescription")}
          </Typography.Paragraph>
        )}
        {selectedMethod === "email" && (
          <Typography.Paragraph style={{ color: "#fff", textAlign: "left" }}>
            {t("pages.Diagnostic.shareModalEmailDescription")}
          </Typography.Paragraph>
        )}
        <Row justify="center" style={{ marginTop: "16px" }}>
          <Col style={{ textAlign: "center" }}>
            <Radio.Group
              onChange={(evt) => setSelectedMethod(evt.target.value)}
              value={selectedMethod}
            >
              <Radio.Button value="link">
                {t("pages.Diagnostic.byLink")}
              </Radio.Button>
              <Radio.Button value="email">
                {t("pages.Diagnostic.byMail")}
              </Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
        {selectedMethod === "link" && (
          <Row justify="center">
            <Col xs={20}>
              <div style={{ textAlign: "end", minHeight: 247 }}>
                <Input
                  value={diagnosis?.diagResulUrl}
                  disabled
                  style={{ marginTop: 30 }}
                />
                <FontAwesomeIcon
                  icon={faCopy}
                  onClick={onClickCopy}
                  style={{ cursor: "pointer" }}
                />{" "}
                <span
                  onClick={onClickCopy}
                  style={{ textTransform: "uppercase", cursor: "pointer" }}
                >
                  {t("pages.Diagnostic.copyLink")}
                </span>
              </div>
            </Col>
          </Row>
        )}
        {selectedMethod === "email" && (
          <Row justify="center">
            <Col xs={20}>
              <Form form={form} onFinish={onFinish} layout="vertical">
                <Form.Item
                  name="nameReceiver"
                  label={t("pages.Diagnostic.name")}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="emailReceiver"
                  label={t("pages.Diagnostic.email")}
                >
                  <Input />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        )}
      </div>
    </Modal>
  );
};

export default ModalShareDiagnosis;
